import VxeInputConstructor from './src/input';
import { dynamicApp } from '../dynamics';
export var VxeInput = Object.assign(VxeInputConstructor, {
    install: function (app) {
        app.component(VxeInputConstructor.name, VxeInputConstructor);
    }
});
export var Input = VxeInput;
dynamicApp.component(VxeInputConstructor.name, VxeInputConstructor);
export default VxeInput;
